import { Component, Output, EventEmitter } from '@angular/core';
import * as firebase from 'firebase';
import { FirebaseCmsService } from './../../providers/firebase-cms.service';
import { Form } from '@angular/forms';


@Component({
  selector: 'app-cms-user',
  template: `<section class="login">

  <div *ngIf=" ! cms.isLogin ">

    <div>
      <button (click)="onClickGoogleLogin()">Google Login</button>
    </div>



    <div>
      <form #loginForm (ngSubmit)=" onLoginFormSubmit( $event, loginForm ) ">
        <div>
          <label>Email:</label>
          <span>
            <input type="email" name="email" [(ngModel)]="email">
          </span>
        </div>
        <div>
          <label>Password:</label>
          <span>
            <input type="password" name="password" [(ngModel)]="password">
          </span>
        </div>
        <div *ngIf=" ! show.register ">
          <button type="submit">Login</button>
          <button type="button" (click)=" show.register = true ">Or Register</button>
        </div>

        <ng-container *ngIf=" show.register ">
          <div>
            <label>Name:</label>
            <span>
              <input type="text" name="name" [(ngModel)]="name">
            </span>
          </div>
          <div>
            <label>Mobile No.:</label>
            <span>
              <input type="number" name="mobile" [(ngModel)]="mobile">
            </span>
          </div>
          <button type="submit">Register</button>
          <button type="button" (click)=" show.register = false ">Cancel</button>
        </ng-container>

      </form>
    </div>

  </div>

  <div *ngIf=" cms.isLogin ">
    <h2>Hello {{ cms.userDisplayName }}!</h2>
    <div>
      <button (click)=" show.profile = true ">Update Profile</button>
      <button (click)=" onClickLogout() ">Logout</button>
    </div>
    <div *ngIf=" show.profile ">
      <h3>Profile Update</h3>
      <form #profileForm (ngSubmit)=" onProfileUpdateFormSubmit( $event, profileForm ) ">
        <div>
          <label>Name:</label>
          <span>
            <input type="text" name="name" [(ngModel)]="name">
          </span>
        </div>
        <div>
          <label>Mobile No.:</label>
          <span>
            <input type="number" name="mobile" [(ngModel)]="mobile">
          </span>
        </div>
        <button type="submit">UPDATE</button>
        <button type="button" (click)=" show.profile = false ">Cancel</button>
      </form>
    </div>
  </div>

</section>
`
})
export class UserComponent {

  email: string = null;
  password: string = null;
  mobile: number = null;
  name: string = null;

  // mode: 'login' | 'register' = 'login';
  show: {
    register: false;
    profile: boolean;
  } = {
      register: false,
      profile: false
    };

  @Output() login = new EventEmitter<void>();
  constructor(public cms: FirebaseCmsService) {
    console.log(cms.afAuth);
  }


  onClickGoogleLogin() {
    this.cms.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(user => {
        console.log("Google login ok", user);
        this.login.emit();
      })
      .catch(e => {
        console.error('Google login failed with ....: ', e);
      });
  }


  onClickLogout() {
    this.cms.logout();
  }


  onProfileUpdateFormSubmit(event: Event, form) {
    event.preventDefault();
    this.cms.profileUpdate({
      name: this.name,
      mobile: this.mobile,
      debug: true
    }).then(re => {
      console.log(re);
    }).catch(e => {
      console.log("Caught: ", e instanceof Error);
      console.error(e);
      alert(e.message);
    });
    return false;
  }


  onLoginFormSubmit(event: Event, form) {
    event.preventDefault();
    if (this.show.register === false) {
      this.onClickLogin();
    }
    else {
      this.onClickRegister();
    }
    return false;
  }

  onClickLogin() {
    this.cms.login(this.email, this.password)
      .then(re => {
        console.log("onClickLogin() => cms.login() => re: ", re);
      })
      .catch(e => {
        alert(e.message);
      });
  }
  onClickRegister() {
    this.cms.register({
      email: this.email,
      password: this.password,
      name: this.name,
      mobile: this.mobile
    })
      .then(re => {
        console.log('cms.register() => then: ', re);
        return this.cms.login(this.email, this.password);
      })
      .then(re => {
        console.log('login: ', re);
      });
  }

}
